import strFunc from "@/lib/lyg/string";
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import { useState } from 'react';
import Style from "./css/style.module.css";
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import TextBookAddWordPopup from "@/pages/comp/plan/word/word_inside/popup/add_word";

function WordListArea(props: any) {
  let myProps = {
    infoArr: [],
    setInfoArr: (inData: any) => { },
    refreshData: (inData: any) => { },
    g_par_id: "",
    g_par_seq: "",
    ...props
  };

  const [selectedWords, setSelectedWords] = useState<string[]>([]);
  const [draggedItem, setDraggedItem] = useState<any>(null);
  const [editedWords, setEditedWords] = useState<{ [key: string]: any }>({});

  // 수정된 단어 데이터 가져오기 (수정된 것이 있으면 수정본, 없으면 원본)
  const getEditedWord = (word: any) => {
    return editedWords[word.a_word_seq] || word;
  };

  // 단어 데이터 변경 핸들러
  const handleWordChange = (seq: string, field: string, value: string) => {
    let change_info_arr: any = [...myProps.infoArr];
    for (let i = 0; i < myProps.infoArr.length; i++) {
      let item = myProps.infoArr[i];
      if (item.a_word_seq == seq) {
        item[field] = value;
        change_info_arr[i] = item;
      }
    }
    myProps.setInfoArr(change_info_arr);

    const originalWord = myProps.infoArr.find((w: any) => w.a_word_seq === seq);
    setEditedWords({
      ...editedWords,
      [seq]: {
        ...originalWord,
        ...editedWords[seq],
        [field]: value
      }
    });
  };

  // 키보드 네비게이션 핸들러
  const handleKeyDown = (e: React.KeyboardEvent, wordSeq: string, currentField: string) => {
    const currentInput = e.currentTarget as HTMLInputElement;
    const wordItems = document.querySelectorAll(`.${Style.wordItem}`);
    let currentIndex = -1;

    // 현재 아이템의 인덱스 찾기
    wordItems.forEach((item, index) => {
      if (item.contains(currentInput)) {
        currentIndex = index;
      }
    });

    if (currentIndex === -1) return;

    if (e.key === 'Enter') {
      e.preventDefault();

      // 같은 행의 다음 필드로 이동
      if (currentField === 'a_word') {
        const meanInput = wordItems[currentIndex].querySelector('input[placeholder="뜻"]') as HTMLInputElement;
        if (meanInput) meanInput.focus();
      } else if (currentField === 'a_mean') {
        // 뜻 입력 후 엔터 시 저장
        const isEdited = !!editedWords[wordSeq];
        if (isEdited) {
          saveWord(wordSeq);
        }
        // 다음 행의 단어 input으로 이동
        if (currentIndex < wordItems.length - 1) {
          const nextWordInput = wordItems[currentIndex + 1].querySelector('input[placeholder="단어"]') as HTMLInputElement;
          if (nextWordInput) nextWordInput.focus();
        }
      }
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      // 위쪽 행의 같은 필드로 이동
      if (currentIndex > 0) {
        const prevItem = wordItems[currentIndex - 1];
        const targetInput = prevItem.querySelector(`input[placeholder="${currentField === 'a_word' ? '단어' : '뜻'}"]`) as HTMLInputElement;
        if (targetInput) targetInput.focus();
      }
    } else if (e.key === 'ArrowDown') {
      e.preventDefault();
      // 아래쪽 행의 같은 필드로 이동
      if (currentIndex < wordItems.length - 1) {
        const nextItem = wordItems[currentIndex + 1];
        const targetInput = nextItem.querySelector(`input[placeholder="${currentField === 'a_word' ? '단어' : '뜻'}"]`) as HTMLInputElement;
        if (targetInput) targetInput.focus();
      }
    }
  };
  const default_popup_data = {
    isOpen: false,
    sort: "manage_textbook_sort",//view
    listOpt: {},
    g_par_id: "",
    g_par_seq: "",
    word_type: "",
    title: "팝업",
    width: "100%",
    height: "90%",
  };
  const [popupData, setPopupData] = useState({ ...default_popup_data });

  const open_add_word_popup = (inData: any) => {
    let opt_obj = {
      g_par_id: myProps.g_par_id,
      g_par_seq: myProps.g_par_seq,
      word_type: "word",//stc
      ...inData
    };

    if (myProps.infoArr.length > 0) {
      if (myProps.infoArr[0].a_cont_part) {
        opt_obj.word_type = myProps.infoArr[0].a_cont_part;
      }
    }

    if (strFunc.is_empty(opt_obj.g_par_id)) {
      alert("분류가 선택되지 않았습니다.");
      return false;
    }
    if (strFunc.is_empty(opt_obj.word_type)) {
      alert("분류키가 선택되지 않았습니다.");
      return false;
    }

    let pop_title = "단어 추가";
    if (opt_obj.word_type === "stc") {
      pop_title = "문장 추가";
    }

    setPopupData({
      ...default_popup_data,
      isOpen: true,
      sort: "add_word",
      g_par_id: opt_obj.g_par_id,
      g_par_seq: opt_obj.g_par_seq,
      word_type: opt_obj.word_type,
      title: pop_title,
      width: "80%",
    });
  };


  const toggleWordSelection = (seq: string) => {
    let change_selected_words = [...selectedWords];
    let is_exist = false;
    for (let i = 0; i < selectedWords.length; i++) {
      if (selectedWords[i] === seq) {
        is_exist = true;
      }
    }
    if (is_exist) {
      change_selected_words = [];
      for (let i = 0; i < selectedWords.length; i++) {
        if (selectedWords[i] !== seq) {
          change_selected_words.push(selectedWords[i]);
        }
      }
    } else {
      change_selected_words.push(seq);
    }
    setSelectedWords(change_selected_words);
  };

  const selectAllWords = () => {
    if (selectedWords.length === myProps.infoArr.length) {
      setSelectedWords([]);
    } else {
      setSelectedWords(myProps.infoArr.map((word: any) => word.a_word_seq));
    }
  };

  const saveSelectedWords = () => {
    if (selectedWords.length === 0) {
      alert('저장할 단어를 선택해주세요.');
      return;
    }

    // 선택된 단어 중 수정된 것만 저장
    let save_data_arr: any = [];
    for (let i = 0; i < myProps.infoArr.length; i++) {
      let item = myProps.infoArr[i];
      if (strFunc.str_in_array(item.a_word_seq, selectedWords) != -1) {
        save_data_arr.push(item);
      }
    }
    let form_json_data = {
      data_arr: save_data_arr,
    };

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/coolen/group_word/write',
      form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          // 저장 성공 시 수정된 단어 목록에서 제거
          const newEditedWords = { ...editedWords };
          save_data_arr.forEach((word: any) => {
            delete newEditedWords[word.a_word_seq];
          });
          setEditedWords(newEditedWords);
          myProps.refreshData({});
        } else {
          alert('저장 중 오류가 발생했습니다.');
        }
      });
  };

  const deleteSelectedWords = () => {
    if (selectedWords.length === 0) {
      alert('삭제할 단어를 선택해주세요.');
      return;
    }

    let del_data_arr: any = [];
    for (let i = 0; i < myProps.infoArr.length; i++) {
      let info = myProps.infoArr[i];
      if (strFunc.str_in_array(info.a_word_seq, selectedWords) != -1) {
        del_data_arr.push(info);
      }
    }

    if (del_data_arr.length === 0) {
      alert('삭제할 단어를 선택해주세요.');
      return;
    }

    if (!confirm(`선택된 ${del_data_arr.length}개의 단어를 삭제하시겠습니까?`)) {
      return;
    }

    let form_json_data = {
      data_arr: del_data_arr,
    };

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/coolen/group_word/delete',
      form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setSelectedWords([]);
          myProps.refreshData({});
        } else {
          alert('삭제 중 오류가 발생했습니다.');
        }
      });
  };

  // 변경된 단어 저장
  const saveWord = (seq: string) => {
    const editedWord = editedWords[seq];
    if (!editedWord) return;

    if (!editedWord.a_word || !editedWord.a_mean) {
      alert('단어와 뜻을 모두 입력해주세요.');
      return;
    }

    let form_json_data = {
      data_arr: [editedWord],
    };

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/coolen/group_word/write',
      form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          // 저장 성공 시 수정된 단어 목록에서 제거
          const newEditedWords = { ...editedWords };
          delete newEditedWords[seq];
          setEditedWords(newEditedWords);
          myProps.refreshData({});
        } else {
          alert('수정 중 오류가 발생했습니다.');
        }
      });
  };

  const handleDragStart = (e: React.DragEvent, word: any) => {
    // 수정된 내용이 있으면 드래그 방지
    if (editedWords[word.a_word_seq]) {
      e.preventDefault();
      return;
    }
    setDraggedItem(word);
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/plain', word.a_word_seq);
  };

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDragEnter = (e: React.DragEvent) => {
    e.preventDefault();
  };

  const handleDrop = (e: React.DragEvent, targetWord: any) => {
    e.preventDefault();
    e.stopPropagation();

    if (!draggedItem || draggedItem.a_word_seq === targetWord.a_word_seq) {
      setDraggedItem(null);
      return;
    }

    const dragIndex = myProps.infoArr.findIndex((item: any) => item.a_word_seq === draggedItem.a_word_seq);
    const dropIndex = myProps.infoArr.findIndex((item: any) => item.a_word_seq === targetWord.a_word_seq);

    if (dragIndex === -1 || dropIndex === -1) {
      setDraggedItem(null);
      return;
    }

    let change_info_arr: any = [];
    for (let i = 0; i < myProps.infoArr.length; i++) {
      let item = myProps.infoArr[i];
      let change_item = { ...item };
      if (item.a_word_seq == draggedItem.a_word_seq) {
        change_item = { ...targetWord };
      }
      if (item.a_word_seq == targetWord.a_word_seq) {
        change_item = { ...draggedItem };
      }
      change_info_arr.push(change_item);
    }
    for (let i = 0; i < change_info_arr.length; i++) {
      change_info_arr[i].a_order_num = i + 1;
    }

    let form_json_data = {
      data_arr: change_info_arr,
    };

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/coolen/group_word/write',
      form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          myProps.refreshData({});
        } else {
          alert('순서 변경 중 오류가 발생했습니다.');
        }
        setDraggedItem(null);
      })
      .catch((error) => {
        console.error('Error reordering words:', error);
        alert('순서 변경 중 오류가 발생했습니다.');
        setDraggedItem(null);
      });
  };

  return (
    <div className={Style.wordListArea}>
      <div className={Style.wordControls}>
        <div className={Style.controlLeft}>
          <button
            className={Style.selectButton}
            onClick={selectAllWords}
          >
            {selectedWords.length === myProps.infoArr.length ? '전체해제' : '전체선택'}
          </button>
          <span className={Style.selectionInfo}>
            선택: {selectedWords.length} / {myProps.infoArr.length}
          </span>

          <span className={Style.controlRight}>
            <button
              className={Style.saveSelectedButton}
              onClick={saveSelectedWords}
              disabled={selectedWords.length === 0}
            >
              선택저장
            </button>
            <button
              className={Style.deleteButton}
              onClick={deleteSelectedWords}
              disabled={selectedWords.length === 0}
            >
              선택삭제
            </button>

            <button className={Style.addButton}
              onClick={() => {
                open_add_word_popup({});
              }}>단어추가</button>
          </span>
        </div>
      </div>

      <div className={Style.wordList}>
        {myProps.infoArr.length === 0 ? (
          <div className={Style.emptyState}>
            등록된 단어가 없습니다.
          </div>
        ) : (
          myProps.infoArr.map((word: any, index: number) => {
            const currentWord = getEditedWord(word);
            const isEdited = !!editedWords[word.a_word_seq];

            let mp3_url = "";
            if (word.word_file_info && word.word_file_info.img_url) {
              mp3_url = word.word_file_info.img_url;
            }

            return (
              <div
                key={index}
                className={`${Style.wordItem} ${selectedWords.includes(word.a_word_seq) ? Style.selected : ''}`}
                draggable={!isEdited}
                onDragStart={(e) => handleDragStart(e, word)}
                onDragOver={handleDragOver}
                onDragEnter={handleDragEnter}
                onDrop={(e) => handleDrop(e, word)}
                style={{
                  opacity: draggedItem && draggedItem.a_word_seq === word.a_word_seq ? 0.5 : 1
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                  <input
                    type="checkbox"
                    checked={selectedWords.includes(word.a_word_seq)}
                    onChange={() => toggleWordSelection(word.a_word_seq)}
                    className={Style.wordCheckbox}
                  />

                  <div className={Style.wordNumber}>
                    {index + 1}
                  </div>

                  <div className={Style.editForm}>
                    <div className={Style.editRow}>
                      <input
                        type="text"
                        className={Style.editInput}
                        value={currentWord.a_word}
                        onChange={(e) => handleWordChange(word.a_word_seq, 'a_word', e.target.value)}
                        onKeyDown={(e) => handleKeyDown(e, word.a_word_seq, 'a_word')}
                        placeholder="단어"
                      />
                      <input
                        type="text"
                        className={Style.editInput}
                        value={currentWord.a_mean}
                        onChange={(e) => handleWordChange(word.a_word_seq, 'a_mean', e.target.value)}
                        onKeyDown={(e) => handleKeyDown(e, word.a_word_seq, 'a_mean')}
                        placeholder="뜻"
                      />
                      <select
                        className={Style.editInput}
                        value={currentWord.a_cont_part || 'word'}
                        onChange={(e) => handleWordChange(word.a_word_seq, 'a_cont_part', e.target.value)}
                      >
                        <option value="word">단어</option>
                        <option value="stc">문장</option>
                      </select>
                      <span>
                        {mp3_url == "" && "없음"}
                        {mp3_url != "" &&
                          <>
                            <button className="btn btn-dark" 
                              onClick={()=>{
                                window.open(mp3_url);
                              }} >mp3</button>
                          </>
                        }
                      </span>
                    </div>
                    {isEdited && (
                      <div className={Style.wordActions}>
                        <button
                          className={`${Style.actionButton} ${Style.saveButton}`}
                          onClick={() => saveWord(word.a_word_seq)}
                        >
                          저장
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} >
          {popupData.sort === "add_word" &&
            <TextBookAddWordPopup
              g_par_id={popupData.g_par_id}
              g_par_seq={popupData.g_par_seq}
              word_type={popupData.word_type}
              callbackData={(inData: any) => { }}
              refreshData={(inData: any) => { myProps.refreshData({}); }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}></TextBookAddWordPopup>
          }
        </LayerPopup>
      }
    </div>
  );
};

export default WordListArea;